webpackJsonp([274346788566796],{

/***/ 1595:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpdateStockTransferRequestItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"requestedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-update-stock-transfer-request-item-input-ebbbb4c7a3865bc3ef3e.js